import { cardComponentsList } from "./dashboardMappings.js";
import { imageNames } from "@/src/constants/imageConstants.js";
import { commonDateOptions } from "@/src/constants/filterConstants.js";
import AICard from "@/src/components/dashboard_components/cards/AICard.vue";
import HomeRecommendedPrompts from "@/src/views/home/v1/HomeRecommendedPrompts.vue";
import DynamicCRMCard from "@/src/components/dashboard_components/cards/DynamicCRMCard.vue";
import AlertStreamCard from "@/src/components/dashboard_components/cards/AlertStreamCard.vue";
import ProjectTaskCard from "@/src/components/dashboard_components/cards/ProjectTaskCard.vue";
import AnalyticsDashboardCard from "@/src/components/dashboard_components/cards/AnalyticsDashboardCard.vue";

export const layoutOptions = [
  {
    id: "single_column",
    label: "1 Column",
    value: 1,
    icon: imageNames.SINGLE_COLUMN,
  },
  {
    id: "double_column",
    label: "2 Column",
    value: 2,
    icon: imageNames.DOUBLE_COLUMN,
  },
];

export const cardOptionTypes = {
  AI: "ai",
  TABLE: "table",
  NUMBER: "number",
  GRAPH: "graph",
};

export const cardOptionsMapping = {
  [cardOptionTypes.AI]: {
    id: cardOptionTypes.AI,
    icon: imageNames.AI_CARD_ICON,
  },
  [cardOptionTypes.TABLE]: {
    id: cardOptionTypes.TABLE,
    icon: imageNames.TABLE_CARD_ICON,
  },
  [cardOptionTypes.NUMBER]: {
    id: cardOptionTypes.NUMBER,
    icon: imageNames.NUMBER_CARD_ICON,
  },
  [cardOptionTypes.GRAPH]: {
    id: cardOptionTypes.GRAPH,
    icon: imageNames.GRAPH_CARD_ICON,
  },
};

export const cardComponentKeyMapping = {
  [cardComponentsList.AI_CARD]: AICard,
  [cardComponentsList.LEAD_TABLE]: DynamicCRMCard,
  [cardComponentsList.CONTACT_TABLE]: DynamicCRMCard,
  [cardComponentsList.COMPANY_TABLE]: DynamicCRMCard,
  [cardComponentsList.CUSTOMER_TABLE]: DynamicCRMCard,
  [cardComponentsList.DEAL_TABLE]: DynamicCRMCard,
  [cardComponentsList.CRM_TASK_TABLE]: DynamicCRMCard,
  [cardComponentsList.RECOMMENDED_LEADS_TABLE]: HomeRecommendedPrompts,
  [cardComponentsList.ANALYTICS]: AnalyticsDashboardCard,
  [cardComponentsList.TASK_TABLE]: ProjectTaskCard,
  [cardComponentsList.ALERT_STREAM]: AlertStreamCard,
};

export const cardPlaceholderImages = {
  dark: "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/dashboards/dark/placeholder.svg",
  light:
    "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/dashboards/light/placeholder.svg",
};

export const defaultDashboardName = "Untitled Dashboard";

export const globalDatePresetOptions = [
  ...commonDateOptions.filter((o) => o.id !== "custom"),
  { id: "this_month", name: "This Month" },
  { id: "last_month", name: "Last Month" },
  { id: "next_7_days", name: "Next 7 days" },
  { id: "custom", name: "Custom" },
];

export const ownerFieldByObject = {
  customers: "customer_owner",
  tasks: "assignees",
  tickets: "assignees",
  deals: "deal_owner_id",
  calls: "user_id",
  sequences: "assigned_to_id",
  meetings: "created_by",
  crm_tasks: "assigned_to",
  emails : "owner_user_id"
};

export const defaultOwnerField = "owner_id";

// Mirrors backend: GetTimestampColumn in external_objects.go (line 315-320)
export const dateFieldByObject = {
  emails: "email_date",
  sequences: "event_timestamp",
};

export const defaultDateField = "created_at";

export const globalFilterConfig = {
  dashboards: {
    created_at: {
      id: "created_date",
      name: "Created Date",
      type: "date",
      datatype: "Date",
      options: [],
      searchable: false,
      multiSelect: false,
      showInitials: false,
      attribute_id: "created_at",
    },
    user: {
      id: "user",
      name: "User",
      type: "user",
      datatype: "User",
      options: [],
      searchable: true,
      multiSelect: false,
      showInitials: true,
      attribute_id: "user_id",
    },
  },
};
